import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import Toastr from "../../../Validations/Toastr";
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import moment from 'moment';
import {fetchUserProfile, updateUserProfile, fetchUserFriendDropdown, deleteProfileDetail} from "../../../../actions/userAction";
import {fetchCountryList, fetchStateList, fetchCityList, fetchProfileIDList, fetchProfileProfessionList, fetchCategoryList} from "../../../../actions/commonAction";
import iconPath from "./../../../../helpers/iconHelper";
import ViewmoreModal   from "./ViewmoreModal";
import AddmoreModal   from "./AddmoreModal";
import AutoComplete   from "./../../../Common/countryDropdown";
import StateDropdown   from "./../../../Common/stateDropdown";
import CityDropdown from "./../../../Common/cityDropdown";
import IdtypeDropdown from "./../../../Common/idtypeDropdown";
import ProfessionDropdown from "./../../../Common/professionDropdown";
import DatePicker from "./../../../Common/datepicker";
import { encrypt , decrypt } from "../../../../helpers/CryptoJs";
import { getlanguagelist } from "../../../../helpers/changelanguage";
import "../TabPanel.css";
class UserAboutEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      urlId                : this.props.urlId,
      userProfile          : {},
      is_control           : false,
      modal_open           : false,
      viewmore_data        : [],
      viewmore_privacy     : null,
      viewmore_title       : null,
      countryList          : null,
      stateList            : null,
      cityList             : null,
      professionList       : null,
      idList               : null,
      about_me             : '',
      is_country_change    : 0,
      about_me_control     : 'PUBLIC',
      title                : '',
      title_control        : 'PUBLIC',
      first_name           : '',
      first_name_control   : 'PUBLIC',
      last_name            : '',
      last_name_control    : 'PUBLIC',
      dob                  : '',
      dob_control          : 'PUBLIC',
      gender               : 'M',
      gender_control       : 'PUBLIC',
      country_code         : '', 
      country_name         : '',
      country_name_control : 'PUBLIC',
      state_id             : '',
      state_name           : '',
      state_name_control   : 'PUBLIC',
      city_id              : '',
      city_name            : '',
      zip_name             : '',
      zip_name_control     : 'PUBLIC',
      residency_name       : '',
      residency_name_control: 'PUBLIC',
      id_type               : '',
      id_type_id            : '',
      id_type_value         : '',
      id_type_value_control : 'PUBLIC',
      work_title            : '',
      work_position         : '',
      work_position_control : 'PUBLIC',
      addmodal_open         : false,
      addmodal_title        : '',
      addmodal_privacy      : 'PUBLIC',
      addmodal_category_dropdown: [],
      addmodal_friend_dropdwon: [],
      addmore_catid         : '',
      addmore_catname       : '',
      addmore_frndid        : '',
      addmore_frndname      : '',
     
    }
    this.fetchProfile           = this.fetchProfile.bind(this);
    this.handleOpen             = this.handleOpen.bind(this);
    this.handleClose            = this.handleClose.bind(this);
    this.handleChange           = this.handleChange.bind(this);
    this.fetchCountry           = this.fetchCountry.bind(this);
    this.fetchState             = this.fetchState.bind(this);
    this.fetchCity              = this.fetchCity.bind(this);
    this.fetchId                = this.fetchId.bind(this);
    this.fetchProfession        = this.fetchProfession.bind(this);
    this.changeCountry          = this.changeCountry.bind(this);
    this.changeState            = this.changeState.bind(this);
    this.changeCity             = this.changeCity.bind(this);
    this.changeId               = this.changeId.bind(this);
    this.changeProfession       = this.changeProfession.bind(this);
    this.onSubmit               = this.onSubmit.bind(this);
    this.updateProfile          = this.updateProfile.bind(this);
    this.addhandleOpen          = this.addhandleOpen.bind(this);
    this.addhandleClose         = this.addhandleClose.bind(this);
    this.fetchCategoryDropdown  = this.fetchCategoryDropdown.bind(this);
    this.fetchFriendDropdown    = this.fetchFriendDropdown.bind(this);
    this.changeCategory         = this.changeCategory.bind(this);
    this.changeFriendDropdown   = this.changeFriendDropdown.bind(this);
    this.addMore                = this.addMore.bind(this);
    this.changeAddmoreprivacy   = this.changeAddmoreprivacy.bind(this);
    this.deleteRow              = this.deleteRow.bind(this);
  }
  componentDidMount() {
      
    if(this.props.changeTab.usertabindex == 3){
       this.fetchProfile();
    }
    
  }

  
  fetchProfile(){
    this.props.fetchUserProfile(this.state);
  }
  fetchCountry(){
    this.props.fetchCountryList();
  }
  fetchState(countryId){
    this.props.fetchStateList(countryId);
  }
  fetchCity(stateId){
    this.props.fetchCityList(stateId);
  }
  fetchId(countryId){
    this.props.fetchProfileIDList(countryId);
  }
  fetchProfession(){
    this.props.fetchProfileProfessionList();
  }
  fetchCategoryDropdown(type){
    this.props.fetchCategoryList(type);
  }

  fetchFriendDropdown(type){
    this.props.fetchUserFriendDropdown(type);
  }

  updateProfile(param){
    this.props.updateUserProfile(param);
  }
  handleOpen(data,privacy,header){
    this.setState({
        modal_open       : true,   
        viewmore_data    : data,
        viewmore_privacy : privacy,
        viewmore_title   : header   
    });
  };
  addhandleOpen(type){
   
    if(type == 'Relationship'){
        // relation and friend dropdown
        this.fetchCategoryDropdown('RELATIONSHIP');
        this.fetchFriendDropdown('ALL');

    }else if(type == 'Social Status'){
         // social and friend dropdown
        this.fetchCategoryDropdown('SOCIAL STATUS');
        this.fetchFriendDropdown('ALL');
    }else if(type == 'Profession'){
        this.fetchCategoryDropdown('PROFESSION');
         // profession 
    }else if(type == 'Hobby'){
         // hobby 
        this.fetchCategoryDropdown('HOBBY');
       
    }else if(type == 'Education'){
        // education 
        this.fetchFriendDropdown('PAGE');
    }else{
        //doing nothing
    }
    this.setState({
        addmodal_open   : true,  
        addmodal_title  : type,
        /* viewmore_data    : data,
        viewmore_privacy : privacy,
        viewmore_title   : header    */
    });
  };

  handleClose(){
    this.setState({
        modal_open : false
    });
  };

  addhandleClose(){
    this.setState({
        addmodal_open               : false,
        addmodal_title              : '',
        addmodal_friend_dropdwon    : [],
        addmodal_category_dropdown  : [],
        addmodal_privacy            : 'PUBLIC',
        addmore_catid               : '',
        addmore_catname             : '',
        addmore_frndid              : '',
        addmore_frndname            : '',
    });
  };
  addMore(){
    let submit_param = {
        'field_type'   : 'Others',
        'updated_field': JSON.stringify(
                            [{"key":this.state.addmodal_title,"value":((this.state.addmodal_title != 'Education') ? this.state.addmore_catid : this.state.addmore_frndid),"friend_id": ((this.state.addmodal_title != 'Education') ?  this.state.addmore_frndid: ''),"control":this.state.addmodal_privacy}]
                         )
    }; 
    this.addhandleClose();
    this.updateProfile(submit_param);
    this.fetchProfile();
  }
  changeAddmoreprivacy(val){
    
    this.setState({
        addmodal_privacy : val
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps,prevProps){

        /* if((nextProps.changeTab.usertabindex == 3) && (this.props.changeTab.usertabindex != nextProps.changeTab.usertabindex)){
            this.changeview('view')
        } */

        if((decrypt(window.location.href.split('/')[4]) != this.props.urlId) && (this.props.changeTab.usertabindex == nextProps.changeTab.usertabindex)){
       
            this.changeview('view')
        }  
        if((nextProps.changeTab.usertabindex == 3) && (this.props.changeTab.usertabindex != nextProps.changeTab.usertabindex)){
            this.fetchProfile();
        }
        if((Object.keys(nextProps.userprofiledetail.profile).length > 0) && (this.state.is_country_change == 0)){
            if(nextProps.countryList == null){
                //call country api
                this.fetchCountry();
                this.fetchProfession();
            }else{
                if((nextProps.stateList == null) && (nextProps.userprofiledetail.profile.country_code != '')){
                    this.fetchState(nextProps.userprofiledetail.profile.country_code);
                    this.fetchId(nextProps.userprofiledetail.profile.country_code);
                }else{
                    if((nextProps.cityList == null) && (nextProps.userprofiledetail.profile.state_id != '')){
                        this.fetchCity(nextProps.userprofiledetail.profile.state_id);
                    }
                }
            }
        
                this.setState({
                    userProfile           :  nextProps.userprofiledetail.profile,
                    is_control            :  (nextProps.currentUserDetails.id == this.state.urlId) ? true : false,
                    about_me              :  nextProps.userprofiledetail.profile.about_me.value,
                    about_me_control      :  nextProps.userprofiledetail.profile.about_me.privacy,
                    title                 :  nextProps.userprofiledetail.profile.title.value,
                    title_control         :  nextProps.userprofiledetail.profile.title.privacy,
                    first_name            :  nextProps.userprofiledetail.profile.first_name.value,
                    first_name_control    :  nextProps.userprofiledetail.profile.first_name.privacy,
                    last_name             :  nextProps.userprofiledetail.profile.last_name.value,
                    last_name_control     :  nextProps.userprofiledetail.profile.last_name.privacy,
                    dob                   :  nextProps.userprofiledetail.profile.dob.value,
                    dob_control           :  nextProps.userprofiledetail.profile.dob.privacy,
                    gender                :  nextProps.userprofiledetail.profile.gender.value,
                    gender_control        :  nextProps.userprofiledetail.profile.gender.privacy,
                    country_code          :  nextProps.userprofiledetail.profile.country_code,
                    country_name          :  nextProps.userprofiledetail.profile.country_name.value,
                    country_name_control  :  nextProps.userprofiledetail.profile.country_name.privacy,
                    state_id              :  nextProps.userprofiledetail.profile.state_id,
                    state_name            :  nextProps.userprofiledetail.profile.state.value,
                    city_id               :  nextProps.userprofiledetail.profile.city_id,
                    city_name             :  nextProps.userprofiledetail.profile.city.value,
                    zip_name              :  nextProps.userprofiledetail.profile.zipcode.value,
                    residency_name        :  nextProps.userprofiledetail.profile.residence_address.value,
                    id_type               : nextProps.userprofiledetail.profile.id_type,
                    id_type_id            : nextProps.userprofiledetail.profile.id_type_id,
                    id_type_value         : nextProps.userprofiledetail.profile.id_number.value,
                    id_type_value_control : nextProps.userprofiledetail.profile.id_number.privacy,
                    work_title            : nextProps.userprofiledetail.profile.work_title,
                    work_title_id         : nextProps.userprofiledetail.profile.work_title_id,
                    work_position         : nextProps.userprofiledetail.profile.work.value,
                    work_position_control : nextProps.userprofiledetail.profile.work.privacy, 
                });
        
        }
        if((nextProps.countryList != null) || (this.state.is_country_change == 1)){
            this.setState({
                countryList : nextProps.countryList
            })
        }
        if((nextProps.stateList != null) || (this.state.is_country_change == 1)){
            this.setState({
                stateList : nextProps.stateList
            })
        }
        if((nextProps.cityList != null) || (this.state.is_country_change == 1)){
            this.setState({
                cityList : nextProps.cityList
            })
        }
        if(nextProps.idList != null){
            this.setState({
                idList : nextProps.idList
            })
        }
        if(nextProps.professionList != null){
            this.setState({
                professionList : nextProps.professionList
            })
        }
        
        if(this.addmodal_title != ''){
            this.setState({
                addmodal_category_dropdown : nextProps.categoryList,
                addmodal_friend_dropdwon   : nextProps.frienddropdownList
            })
        }

   }

  changeview(type){
    this.props.changeview(type);
  }
  handleChange(e) {
    this.setState({
        [e.target.name] : e.target.value,
    });
  }

  changeCountry(countryData){
     this.setState({
        country_code          :  countryData.country_code,
        country_name          :  countryData.country_name,
        is_country_change     :  1,
        state_id              :  '',
        state_name            :  '',
        city_id               :  '',
        city_name             :  '',
        zip_name              :  '',
        residency_name        :  ''
    }) 
    this.fetchState(countryData.country_code);
    
  }

  changeState(stateData){
    this.setState({
       is_country_change     :  1,
       state_id              :  stateData.id,
       state_name            :  stateData.name,
       city_id               :  '',
       city_name             :  '',
       zip_name              :  '',
       residency_name        :  ''
   }) 
   this.fetchCity(stateData.id);
   
 }

 changeCity(cityData){
    this.setState({
       is_country_change     :  1,
       city_id               :  cityData.id,
       city_name             :  cityData.name,
       zip_name              :  '',
       residency_name        :  ''
   }) 
     
 }

 changeId(idData){
    this.setState({
        id_type             : idData.id_type,
        id_type_id          : idData.id_type_id,
        id_type_value       : '',
   }) 
     
 }

 changeProfession(professionData){
    this.setState({
        work_title            : professionData.work_title,
        work_title_id         : professionData.work_title_id,
        work_position         : ''
    })
     
 }
 changeCategory(category){
    this.setState({
        addmore_catid        : category.id,
        addmore_catname      : category.name
    })
    
 }

 changeFriendDropdown(friend){
    this.setState({
        addmore_frndid        : friend.id,
        addmore_frndname      : friend.name
    })
    
 }
  
 deleteRow(id,type){
    
    this.props.deleteProfileDetail(id,type);
    this.handleClose();
   // $(`#${type}${id}`).remove();
    let userProfile      = this.state.userProfile || {};
    if(type == 'Relationship'){
        let matchedIndex =    userProfile.relationship.map(function (obj) { return obj.id; }).indexOf(id);
        if(matchedIndex >= 0){
            userProfile.relationship.splice(matchedIndex, 1);
            this.setState({
                userProfile : userProfile
            })
        }
    }else if(type == 'Hobby'){
        let matchedIndex =    userProfile.hobby.map(function (obj) { return obj.id; }).indexOf(id);
        if(matchedIndex >= 0){
            userProfile.hobby.splice(matchedIndex, 1);
            this.setState({
                userProfile : userProfile
            })
        }
    }else if(type == 'Profession'){
        let matchedIndex =    userProfile.profession.map(function (obj) { return obj.id; }).indexOf(id);
        if(matchedIndex >= 0){
            userProfile.profession.splice(matchedIndex, 1);
            this.setState({
                userProfile : userProfile
            })
        }
    }else if(type == 'Education'){
        let matchedIndex =    userProfile.education.map(function (obj) { return obj.id; }).indexOf(id);
        if(matchedIndex >= 0){
            userProfile.education.splice(matchedIndex, 1);
            this.setState({
                userProfile : userProfile
            })
        }
    }
    
    //this.fetchProfile();
 }

onSubmit(e){
    e.preventDefault();
    let submit_param = {
        'field_type'   : 'Basic',
        'updated_field': JSON.stringify(
                            [
                            {"key":"about_me","value":this.state.about_me,"control":"PUBLIC"},
                            {"key":"title","value":this.state.title,"control":this.state.title_control},
                            {"key":"first_name","value":this.state.first_name,"control":this.state.first_name_control},
                            {"key":"last_name","value":this.state.last_name,"control":this.state.last_name_control},
                            {"key":"dob","value":this.state.dob,"control":this.state.dob_control},
                            {"key":"gender","value":this.state.gender,"control":this.state.gender_control},
                            {"key":"country","value":this.state.country_code,"control":this.state.country_name_control},
                            {"key":"state","value":this.state.state_id,"control":this.state.country_name_control},
                            {"key":"city","value":this.state.city_id,"control":this.state.country_name_control},
                            {"key":"zipcode","value":this.state.zip_name,"control":this.state.country_name_control},
                            {"key":"residence_address","value":this.state.residency_name,"control":this.state.country_name_control},
                            {"key":"id_number","value":this.state.id_type_value,"control":this.state.id_type_value_control,"id_type":this.state.id_type_id},
                            {"key":"work","value":this.state.work_position,"control":this.state.work_position_control,"work_title":this.state.work_title_id}
                            ]
                        )
    }; 
    this.updateProfile(submit_param);
}

  render() {
    let userProfile      = this.state.userProfile || {};
    let countuserProfile = Object.keys(userProfile).length;
    let viewControl      = this.state.is_control
    let  languagelist    = getlanguagelist();

    return (
        
        <div>
            <form id="user-profile" onSubmit={this.onSubmit}>
                <div className="row">
                        {/* About me */}
                        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                            <div className="left_fixt">
                                <div className="post_box known">
                                    <h3>{languagelist.description}</h3>
                                    <div className="description_box">
                                       
                                        <textarea className="description_fild" style={{ width: '100%', height: '200px'}} name="about_me" defaultValue={this.state.about_me} onChange={this.handleChange}></textarea>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-9 post_area">
                            <div className="row margin-row">
                            {/* personal details */}
                            <div className="post_box known">
                            
                                <h3>
                                    <span className="pull-left">{languagelist.personalinfo}</span> 
                                    <span className="pull-right"> 
                                        <button className="btn_3" onClick={()=>this.changeview('view')}><i className="fa fa-eye"></i> {languagelist.viewbtn} </button>
                                        <button className="btn_3"  type="submit"> <i className="fa fa-check-square"></i> {languagelist.updatebtn} </button>
                                    </span>
                                </h3>
                                <div className="clr20"></div>

                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.title}</label>
                                            {/* <input type="text" name="title" value={this.state.title} onChange={this.handleChange}/> */}
                                            <div className="custom-select" >
                                                <select className="form-control gender_sel" name="title" value={this.state.title} onChange={this.handleChange}>
                                                    <option value="" >{languagelist.title}</option>
                                                    <option value="Mr." >{languagelist.mr}</option>
                                                    <option value="Ms." >{languagelist.ms}</option>
                                                    <option value="Mrs." >{languagelist.mrs}</option>
                                                    <option value="Dr." >{languagelist.dr}</option>
                                                    <option value="Prof." >{languagelist.prof}</option>
                                                </select>
                                            </div>
                                        </div>
                                        {viewControl ? 
                                            <div className="custom-select" >
                                                <select className="form-control" name="title_control" value={this.state.title_control} onChange={this.handleChange}>
                                                    <option value="PUBLIC" >{languagelist.public}</option>
                                                    <option value="ME" >{languagelist.me}</option>
                                                    <option value="FRIENDS" >{languagelist.pfriend}</option>
                                                </select>
                                            </div>
                                        : null}
                                        <div className="clearfix"></div>
                                       
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.fname}</label>
                                            <input type="text" name="first_name" value={this.state.first_name} onChange={this.handleChange}/>
                                        </div>


                                        {viewControl ? 
                                        <div className="custom-select" >
                                            <select className="form-control" name="first_name_control" value={this.state.first_name_control} onChange={this.handleChange}>
                                                <option value="PUBLIC">{languagelist.public}</option>
                                                <option value="ME">{languagelist.me}</option>
                                                <option value="FRIENDS">{languagelist.pfriend}</option>
                                                
                                            </select>
                                        </div>
                                        : null}
                                        <div className="clearfix"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.lname}</label>
                                            <input type="text" name="last_name" value={this.state.last_name} onChange={this.handleChange} />
                                        </div>
                                        {viewControl ? 
                                            <div className="custom-select" >
                                                <select className="form-control" name="last_name_control" value={this.state.last_name_control} onChange={this.handleChange}>
                                                    <option value="PUBLIC" >{languagelist.public}</option>
                                                    <option value="ME" >{languagelist.me}</option>
                                                    <option value="FRIENDS" >{languagelist.pfriend}</option>
                                                </select>
                                            </div>
                                        : null}
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_dob_icon.png" />
                                        <div className="input_mid pull-left dob-input" style={{width: '100px !important'}}>
                                            <label>{languagelist.dob}</label>
                                            {(this.state.dob != '') ?
                                               <DatePicker defaultVal={moment(this.state.dob).format('DD/MM/YYYY')} onChange={this.handleChange}/>
                                              : null 
                                            }
                                        </div>
                                        {viewControl ? 
                                        <div className="custom-select" >
                                            <select className="form-control" name="dob_control" value={this.state.dob_control} onChange={this.handleChange}>
                                                <option value="PUBLIC" >{languagelist.public}</option>
                                                <option value="ME" >{languagelist.me}</option>
                                                <option value="FRIENDS" >{languagelist.pfriend}</option>
                                            </select>
                                        </div>
                                        : null}
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_gender_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.gender}</label>
                                            <div className="custom-select" >
                                                <select className="form-control  gender_sel" name="gender" value={this.state.gender} onChange={this.handleChange}>
                                                    <option value="F" >{languagelist.female}</option>
                                                    <option value="M" >{languagelist.male}</option>
                                                    <option value="T" >{languagelist.otherg}</option>
                                                </select>
                                            </div>
                                        </div>
                                        {viewControl ? 
                                            <div className="custom-select" >
                                                <select className="form-control" name="gender_control" value={this.state.gender_control} onChange={this.handleChange}>
                                                    <option value="PUBLIC" >{languagelist.public}</option>
                                                    <option value="ME" >{languagelist.me}</option>
                                                    <option value="FRIENDS" >{languagelist.pfriend}</option>
                                                </select>
                                            </div>
                                        : null}
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="clr20"></div>
                            </div>

                            {/* contact details */}
                            <div className="post_box known">
                                <h3>{languagelist.contactd}</h3>
                                <div className="clr20"></div>

                               {/*  <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_phone_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.mobile}</label>
                                            <input type="text" value={(countuserProfile > 0) ? `${userProfile.phone_country_code} ${userProfile.phone.value}` : ''} readOnly />
                                        </div>
                                        {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.phone.privacy] : ''} /></a> : null }
                                    
                                        <div className="clearfix"></div>
                                    </div>
                                </div> */}
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.email}</label>
                                            <input type="text" value={(countuserProfile > 0) ? userProfile.email.value : ''} readOnly/>
                                        </div>
                                        {viewControl ?  <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.email.privacy] : ''} /></a> : null }
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="clr20"></div>
                            </div>

                            {/* address details */}
                            <div className="post_box known">
                                <h3>{languagelist.addressd}
                                {viewControl ? 
                                <div className="custom-select" >
                                    <select className="form-control" name="country_name_control" value={this.state.country_name_control} onChange={this.handleChange}>
                                        <option value="PUBLIC">{languagelist.public}</option>
                                        <option value="ME">{languagelist.me}</option>
                                        <option value="FRIENDS">{languagelist.pfriend}</option>
                                    </select>
                                </div>
                                    
                                : null }
                                </h3>
                                
                                <div className="clr20"></div>

                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_cuntry_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.country}</label>
                                            <AutoComplete dataList={this.state.countryList} defaultVal = {this.state.country_name} changeCountry={this.changeCountry}/>
                                        {/*  <input type="text"  value={(countuserProfile > 0) ? userProfile.country_name.value : ''} readOnly/> */}
                                        </div>
                                        
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_stat_icon.png"/>
                                        <div className="input_mid pull-left">
                                        <label>{languagelist.regi}</label>
                                        <StateDropdown dataList={this.state.stateList} defaultVal = {this.state.state_name} changeState={this.changeState}/>
                                        </div>
                                        {/* {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.state.privacy] : ''}/></a> : null }
                                        */}<div className="clearfix"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_city_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.city}</label>
                                            <CityDropdown dataList={this.state.cityList} defaultVal = {this.state.city_name} changeCity={this.changeCity}/>
                                        </div>
                                        {/* {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.city.privacy] : ''} /></a> : null }
                                        */}<div className="clearfix"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_zif_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.zip}</label>
                                            <input type="text" name="zip_name" value={this.state.zip_name} onChange={this.handleChange} style={{marginTop: '9px'}}/>
                                        </div>
                                        {/* {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.zipcode.privacy] : ''} /></a> : null }
                                        */}<div className="clearfix"></div>
                                          <div className="clr10"></div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_stat_icon.png" />
                                        <div className="input_mid pull-left">
                                            <label>{languagelist.address}</label>
                                            {/* <input type="text" name="residency_name" value={this.state.residency_name} onChange={this.handleChange}/> */}
                                            <textarea name="residency_name" onChange={this.handleChange} value={this.state.residency_name} ></textarea>
                                        </div>
                                        {/* {viewControl ? <a className="pull-right web_button"><img src={(countuserProfile > 0) ? iconPath[userProfile.residence_address.privacy] : ''} /></a> : null }
                                        */}<div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="clr20"></div>
                        </div>
                            
                            {/* other details */}
                            {(countuserProfile > 0) && userProfile.membership == 'GOLD' 
                            ? 
                            <div>
                            <div className="post_box known">
                                <h3>{languagelist.carddetail}

                                    <div className="custom-select" >
                                        <select className="form-control" name="id_type_value_control" value={this.state.id_type_value_control} onChange={this.handleChange}>
                                            <option value="PUBLIC">{languagelist.public}</option>
                                            <option value="ME">{languagelist.me}</option>
                                            <option value="FRIENDS">{languagelist.pfriend}</option>
                                        </select>
                                    </div> 
                                </h3>
                                        
                                        
                                <div className="clr20"></div>
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_idcard_icon.png" />
                                        <div className="input_mid pull-left">
                                            <IdtypeDropdown dataList={this.state.idList} defaultVal = {this.state.id_type} changeId={this.changeId}/>
                                            
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="infi_fild">
                                        <img className="pull-left" src="/assets/images/user_idcard_icon.png" />
                                        <div className="input_mid pull-left">
                                            <input type="text" name="id_type_value" value={this.state.id_type_value} onChange={this.handleChange} />
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="clr20"></div>
                            </div>

                            <div className="post_box known">
                            <h3>{languagelist.profession}
                                <div className="custom-select" >
                                    <select className="form-control" name="work_position_control" value={this.state.work_position_control} onChange={this.handleChange}>
                                        <option value="PUBLIC">{languagelist.public}</option>
                                        <option value="ME">{languagelist.me}</option>
                                        <option value="FRIENDS">{languagelist.pfriend}</option>
                                    </select>
                                </div>

                            </h3>
                                
                            <div className="clr20"></div>
                            <div className="col-lg-6">
                                <div className="infi_fild">
                                    <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                                    <div className="input_mid pull-left">
                                        <ProfessionDropdown dataList={this.state.professionList} defaultVal = {this.state.work_title} changeProfession={this.changeProfession}/>
                                    
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="infi_fild">
                                    <img className="pull-left" src="/assets/images/user_fild_icon.png" />
                                    <div className="input_mid pull-left">
                                        <input type="text" name="work_position" value={this.state.work_position} onChange={this.handleChange} />
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                            </div>
                            <div className="clr20"></div>
                            </div>
                            </div>
                            : null
                            }
                    {/* Relationship */}
                    <div className="clearfix"></div>
                    <div className="sochal_group">
                        <div>
                            <img src="/assets/images/relationship_icon.png" />
                        </div>

                        <div className="sochal_group_right">
                            <div className="relationship_top">
                                <h2>{languagelist.relationshp}</h2>
                                <a href={void(0)} className="addnew_btn" onClick={()=>this.addhandleOpen('Relationship')}>+ {languagelist.addnew}</a>
                            {/*   {(viewControl && (userProfile.total_relationship > 0)) ? <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_relationship > 0)) ? iconPath[userProfile.relationship[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_relationship > 0)) ? userProfile.relationship[0].privacy : null } </a> : null } */}
                            </div>
                            {((countuserProfile > 0) && (userProfile.total_relationship > 0)) ?
                            <div className="relation_outer">
                                {   
                                    (userProfile.relationship).map((relation,index) => {
                                        if(index < 3){
                                            return (
                                            
                                                <div className={(relation.membership == 'GOLD') ? 'relation_user golden_m' : 'relation_user'}  key={`relationship${index}`} id={`Relationship${relation.id}`}>
                                                    <div><img src={(relation.media_link != '') ? relation.media_link : iconPath['DEFAULTUSER']} /></div>
                                                    <div>
                                                        <h4><Link to={`/user/${encrypt(relation.user_id)}`} className="frnds_box" >{relation.full_name}</Link></h4>
                                                        <p>{relation.value}</p>
                                                    </div>
                                                </div>
                                            
                                            )
                                        }
                                    })
                                }
                                <div className="relation_user">
                            
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.relationship,iconPath[`${userProfile.relationship[0].privacy}WHITE`],`${languagelist.relationshp}`)}> 
                                            {(userProfile.total_relationship > 3) ?
                                                `+ ${userProfile.total_relationship - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true"  onClick={()=>this.handleOpen(userProfile.relationship,iconPath[`${userProfile.relationship[0].privacy}WHITE`],'Relationship')}></i>
                                            }  
                                            </a>
                                        </strong><br/> 
                                            {(userProfile.total_relationship > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p>
                                    
                                </div>
                                
                            </div>
                            : null
                            }
                        </div>
                    </div>
                
                    {/* Social */}
                    <div className="clearfix"></div>
                    <div className="sochal_group">
                        <div>
                            <img src="/assets/images/social_status.png" />
                        </div>

                        <div className="sochal_group_right">
                            <div className="relationship_top">
                                <h2>{languagelist.socialstat}</h2>
                                {/*   <a href="#" className="addnew_btn">+ Add New</a> */}
                                <a href={void(0)} className="addnew_btn" onClick={()=>this.addhandleOpen('Social Status')}>+ {languagelist.addnew}</a>
                                {/* {(viewControl && (userProfile.total_social_status > 0)) ? <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_social_status > 0)) ? iconPath[userProfile.social_status[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_social_status > 0)) ? userProfile.social_status[0].privacy : null } </a> : null } */}
                            </div>
                            {((countuserProfile > 0) && (userProfile.total_social_status > 0)) ?
                            <div className="relation_outer">
                                {   
                                    (userProfile.social_status).map((social,index) => {
                                        if(index < 3){
                                        return (
                                            <div className="relation_user" key={`social${index}`}>
                                                <div><img src={(social.media_link != '') ? social.media_link : ''} /></div>
                                                <div>
                                                    <h4>{social.full_name}</h4>
                                                    <p>{social.value}</p>
                                                </div>
                                            </div>
                                        )
                                        }
                                    })
                                }
                                {/* {(userProfile.total_relationship > 3) ?
                                    <div className="relation_user">
                                        <p className="more_group"><strong> +3</strong><br/> MORE</p>
                                    </div>
                                :null
                                } */}
                                
                            </div>
                            : null
                            }
                        </div>
                    </div>
            
                    {/* Education */}
                    <div className="clearfix"></div>
                    <div className="sochal_group">
                        <div>
                            <img src="/assets/images/education_statas.png" />
                        </div>

                        <div className="sochal_group_right">
                            <div className="relationship_top">
                                <h2>{languagelist.education}</h2>
                                {/* <a href="#" className="addnew_btn">+ Add New</a> */}
                                <a href={void(0)} className="addnew_btn" onClick={()=>this.addhandleOpen('Education')}>+ {languagelist.addnew}</a>
                            {/*   {(viewControl && (userProfile.total_education > 0)) ? <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_education > 0)) ? iconPath[userProfile.education[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_education > 0)) ? userProfile.education[0].privacy : null } </a> : null } */}
                            </div>
                            {((countuserProfile > 0) && (userProfile.total_education > 0)) ?
                            <div className="relation_outer">
                                {   
                                    (userProfile.education).map((edu,index) => {
                                        if(index < 3){
                                        return (
                                            <div className="relation_user" key={`education${index}`} id={`Education${edu.id}`}>
                                                <div><img src={(edu.media_link != '') ? edu.media_link : ''} /></div>
                                                <div>
                                                    <h4>{edu.full_name}</h4>
                                                </div>
                                            </div>
                                        )
                                        }
                                    })
                                }
                            
                                <div className="relation_user">

                                   <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.education,iconPath[`${userProfile.education[0].privacy}WHITE`],`${languagelist.education}`)}> 
                                            {(userProfile.total_education > 3) ?
                                                `+ ${userProfile.total_education - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true"  onClick={()=>this.handleOpen(userProfile.education,iconPath[`${userProfile.education[0].privacy}WHITE`],'Education')}></i>
                                            }  
                                            </a>
                                            </strong><br/> 
                                            {(userProfile.total_education > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p>   
                               
                                </div>
                                
                                
                            </div>
                            : null
                            }
                        </div>
                    </div>            
            
                    {/* Profession */}
                    <div className="clearfix"></div>
                    <div className="sochal_group">
                        <div>
                            <img src="/assets/images/profession_statas.png" />
                        </div>

                        <div className="sochal_group_right">
                            <div className="relationship_top">
                                <h2>{languagelist.profession}</h2>
                            {/*   <a href="#" className="addnew_btn">+ Add New</a> */}
                            <a href={void(0)} className="addnew_btn" onClick={()=>this.addhandleOpen('Profession')}>+ {languagelist.addnew}</a>
                            {/*  {(viewControl && (userProfile.total_profession > 0)) ?  <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_profession > 0)) ? iconPath[userProfile.profession[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_profession > 0)) ? userProfile.profession[0].privacy : null } </a> : null } */}
                            </div>
                            {((countuserProfile > 0) && (userProfile.total_profession > 0)) ?
                            <div className="relation_outer">
                                {   
                                    (userProfile.profession).map((prof,index) => {
                                        if(index < 3){
                                        return (
                                            <div className="relation_user" key={`profession${index}`} id={`Profession${prof.id}`}>
                                                <div><img src={(prof.media_link != '') ? prof.media_link : ''} /></div>
                                                <div>
                                                    <h4>{prof.full_name}</h4>
                                                
                                                </div>
                                            </div>
                                        )
                                        }
                                    })
                                }
                                
                                <div className="relation_user">
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.profession,iconPath[`${userProfile.profession[0].privacy}WHITE`],`${languagelist.profession}`)}> 
                                            {(userProfile.total_prof > 3) ?
                                                `+ ${userProfile.total_prof - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true"  onClick={()=>this.handleOpen(userProfile.profession,iconPath[`${userProfile.profession[0].privacy}WHITE`],'Profession')}></i>
                                            }  
                                            </a>
                                            </strong><br/> 
                                            {(userProfile.total_prof > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p> 
                                    {/* {(userProfile.total_prof > 3) ?
                                        <p className="more_group"><strong> +{userProfile.total_profession - 3}</strong><br/> MORE</p>
                                        :null
                                    } */}
                                </div>
                                
                                
                            </div>
                            : null
                            }
                        </div>
                    </div>

                    {/* Hobbies */}
                    <div className="clearfix"></div>
                    <div className="sochal_group">
                        <div>
                            <img src="/assets/images/hobbies_statas.png" />
                        </div>

                        <div className="sochal_group_right">
                            <div className="relationship_top">
                                <h2>{languagelist.hobbies}</h2>
                            {/*  <a href="#" className="addnew_btn">+ Add New</a> */}
                            <a href={void(0)} className="addnew_btn" onClick={()=>this.addhandleOpen('Hobby')}>+ {languagelist.addnew}</a>
                            {/*  {(viewControl && (userProfile.total_hobby > 0)) ?  <a className="pull-right web_button"><img src={((countuserProfile > 0) && (userProfile.total_hobby > 0)) ? iconPath[userProfile.hobby[0].privacy] : null }/> {((countuserProfile > 0) && (userProfile.total_hobby > 0)) ? userProfile.hobby[0].privacy : null } </a> : null } */}
                            </div>
                            {((countuserProfile > 0) && (userProfile.total_hobby > 0)) ?
                            <div className="relation_outer">
                                {   
                                    (userProfile.hobby).map((hobb,index) => {
                                        if(index < 3){
                                        return (
                                            <div className="relation_user" key={`Hobbies${index}`} id={`Hobby${hobb.id}`}>
                                                <div><img src={(hobb.media_link != '') ? hobb.media_link : ''} /></div>
                                                <div>
                                                    <h4>{hobb.full_name}</h4>
                                                
                                                </div>
                                            </div>
                                        )
                                        }
                                    })
                                }
                                
                                <div className="relation_user">
                                    <p className="more_group">
                                        <strong>
                                            <a onClick={()=>this.handleOpen(userProfile.hobby,iconPath[`${userProfile.hobby[0].privacy}WHITE`],`${languagelist.hobbies}`)}> 
                                            {(userProfile.total_hobby > 3) ?
                                                `+ ${userProfile.total_hobby - 3}`
                                                :  <i style={{color:'#4189DD',fontSize: '20px'}} className="fas fa-ellipsis-v" aria-hidden="true" onClick={()=>this.handleOpen(userProfile.hobby,iconPath[`${userProfile.hobby[0].privacy}WHITE`],'Hobby')}></i>
                                            }  
                                            </a>
                                            </strong><br/> 
                                            {(userProfile.total_hobby > 3) ?
                                                `${languagelist.more}`
                                            : null }
                                    </p> 
                               {/*  {(userProfile.total_hobby > 3) ?
                                    <p className="more_group"><strong> +{userProfile.total_hobby - 3}</strong><br/> MORE</p>
                                    :null
                                } */}
                                </div>
                                
                                
                            </div>
                            : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            
                </div>
            </form>
            <ViewmoreModal modalOpen={this.state.modal_open} viewmoreData = {this.state.viewmore_data} viewmorePrivacy = {this.state.viewmore_privacy} viewmoreTitle = {this.state.viewmore_title} handleClose={this.handleClose} viewControl={this.state.is_control} deleteRow={this.deleteRow} page="edit"/>
            <AddmoreModal modalOpen={this.state.addmodal_open} categoryList = {this.state.addmodal_category_dropdown}  friendlist={this.state.addmodal_friend_dropdwon} addmoreTitle = {this.state.addmodal_title} handleClose={this.addhandleClose} changeCategory={this.changeCategory} addmore_catname={this.state.addmore_catname} changeFriendDropdown={this.changeFriendDropdown} addmore_frndname={this.state.addmore_frndname} addmodal_privacy={this.state.addmodal_privacy} addMore={this.addMore} changeAddmoreprivacy={this.changeAddmoreprivacy}/>
            
        </div>
     
    );
  }
}


  const mapStateToProps = state => {
    return {
            currentUserDetails : state.login.user,
            changeTab          : state.activetab,
            userprofiledetail  : state.userprofiledetail,
            countryList        : state.countrylist.countryList,
            stateList          : state.statelist.stateList,
            cityList           : state.citylist.cityList,
            idList             : state.idlist.idList,
            professionList     : state.professionlist.professionList,
            categoryList       : state.categorylist.categoryList,
            frienddropdownList : state.dropdownuserfriend.userFriendDropdown,
           }
  }
  const mapDispatchToProps = dispatch => {
    return{
            fetchUserProfile            : bindActionCreators(fetchUserProfile, dispatch),
            fetchCountryList            : bindActionCreators(fetchCountryList, dispatch),
            fetchStateList              : bindActionCreators(fetchStateList, dispatch),
            fetchCityList               : bindActionCreators(fetchCityList, dispatch),
            fetchProfileIDList          : bindActionCreators(fetchProfileIDList, dispatch),
            fetchProfileProfessionList  : bindActionCreators(fetchProfileProfessionList, dispatch),
            updateUserProfile           : bindActionCreators(updateUserProfile, dispatch),
            fetchCategoryList           : bindActionCreators(fetchCategoryList, dispatch),
            fetchUserFriendDropdown     : bindActionCreators(fetchUserFriendDropdown, dispatch),
            deleteProfileDetail         : bindActionCreators(deleteProfileDetail, dispatch),
          };
  }
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserAboutEdit))